export var AppState;
(function (AppState) {
    AppState["WRITE"] = "WRITE";
    AppState["REVIEW"] = "REVIEW";
    AppState["SEND"] = "SEND";
})(AppState || (AppState = {}));
export var SubscriptionLevel;
(function (SubscriptionLevel) {
    SubscriptionLevel["FREE"] = "FREE";
    SubscriptionLevel["ENTERPRISE"] = "ENTERPRISE";
})(SubscriptionLevel || (SubscriptionLevel = {}));
